import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthContextProvider } from './context/authContext/AuthContext';
import { EnvoieContextProvider } from './context/envoieContext/EnvoieContext';
import { StatistiqueContextProvider } from './context/statistiqueContext/StatistiqueContext';
import { InfopersonContextProvider } from './context/infopersonContext/InfopersonContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StatistiqueContextProvider>
      <InfopersonContextProvider>
        <EnvoieContextProvider>
          <AuthContextProvider>
            <App />
          </AuthContextProvider>
        </EnvoieContextProvider>
      </InfopersonContextProvider>
    </StatistiqueContextProvider>
  </React.StrictMode>
);
